import { axiosInstance } from "@/utilities";
import { API_BASE_URL } from "@/services/XCONS_ENV";

const storeBase = (storeCode: string) =>
  `${API_BASE_URL}/stores/${encodeURIComponent(storeCode)}`;

export interface StoreSettings {
  code: string;
  name: string;
  url: string;
  plan: string;
  status: boolean;
  tax: string;
  whatsapp?: string;
  phone?: string;
  email: string;
}

export async function getStoreSettings(storeCode: string): Promise<StoreSettings> {
  const { data } = await axiosInstance.get<StoreSettings>(storeBase(storeCode));
  return data;
}

export async function updateStoreSettings(
  storeCode: string,
  payload: Partial<StoreSettings>,
): Promise<StoreSettings> {
  const { data } = await axiosInstance.patch<StoreSettings>(storeBase(storeCode), payload);
  return data;
}
